import { isNil, omitBy } from 'lodash';

export const Endpoint = () => `/api/v4/bulletin/get-attachment/`;
export const QueryKey = (payload: Payload) => ['v4', 'bulletins', 'get-attachment', omitBy(payload, isNil)];
export type Payload = {
    id: string;
};
export type Response = { url: string };
